import { render, staticRenderFns } from "./promote-header.vue?vue&type=template&id=61d65de2"
import script from "./promote-header.vue?vue&type=script&lang=ts"
export * from "./promote-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports